export default __webpack_public_path__ + "static/media/blue-line.1b0c86eb.svg";